import React from 'react'
import { WidgetCard } from '../style'
import { QualityIconsContainer, QualityIconItem } from '../widgets/MilkQualityWidget/style'
import { SkeletonLine, SkeletonCircle } from './skeleton.style'

const MilkQualityWidgetSkeleton: React.FC = () => (
  <WidgetCard>
    <SkeletonLine width='120px' height='18px' style={{ marginBottom: '20px' }} />
    <QualityIconsContainer>
      {[...Array(4)].map((_, i) => (
        <QualityIconItem key={i} style={{ cursor: 'default', pointerEvents: 'none' }}>
          <SkeletonLine width='70px' height='20px' />
          <SkeletonCircle size='60px' />
          <SkeletonLine width='50px' height='13px' style={{ marginBottom: 0 }} />
        </QualityIconItem>
      ))}
    </QualityIconsContainer>
  </WidgetCard>
)

export default MilkQualityWidgetSkeleton
